import { render, staticRenderFns } from "./multiply.vue?vue&type=template&id=0a96a418&"
import script from "./multiply.vue?vue&type=script&lang=ts&"
export * from "./multiply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports